/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_x.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Extracts the `x` coordinate from the supplied point.
 * If the point is of type `geo_point` this is equivalent to extracting the `longitude` value.
 *
 * @example
 * ROW point = TO_GEOPOINT("POINT(42.97109629958868 14.7552534006536)")
 * | EVAL x =  ST_X(point), y = ST_Y(point)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_x',
  signatures: [
    {
      params: [
        {
          name: 'point',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'point',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
